import { Action, createReducer, on } from '@ngrx/store';
import { IInventoryManagementState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import { getAuthInfoInventoryManagementFailedAction, getAuthInfoInventoryManagementSuccessAction, getDevicesForCompanyInventoryManagementFailedAction, getDevicesForCompanyInventoryManagementSuccessAction, getLocationsInventoryManagementFailedAction, getLocationsInventoryManagementSuccessAction } from '../actions/inventorymanagement.actions';

const initialState: IInventoryManagementState = {
  permission: null,
  locations: null,
  devices: null
};

export const inventoryManagementReducerImplicit = createReducer(
  initialState,
  on(getAuthInfoInventoryManagementSuccessAction, (state, { data: permission }) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoInventoryManagementFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(getLocationsInventoryManagementSuccessAction, (state, { data: locations }) => ({
    ...state,
    locations
  })),
  on(getLocationsInventoryManagementFailedAction, (state) => ({
    ...state,
    locations: null,
  })),  
  on(getDevicesForCompanyInventoryManagementSuccessAction, (state, { data: devices }) => ({
    ...state,
    devices
  })),
  on(getDevicesForCompanyInventoryManagementFailedAction, (state) => ({
    ...state,
    devices: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
);

export function inventoryManagementReducer(state: any, action: Action): IInventoryManagementState {
  return inventoryManagementReducerImplicit(state, action);
}
